import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectConfig } from '../../../../../shared/ui/form/select/select.component.config';
import { Option } from '../../../../../shared/models/option.model';

@Component({
    selector: 'app-contact-provider-form',
    templateUrl: './contact-provider-form.component.html',
    styleUrls: ['./contact-provider-form.component.css'],
    standalone: false
})
export class ContactProviderFormComponent implements OnInit {
    form!: UntypedFormGroup;

    formConfiguration: any = {
        paymentTypeProvider: {
            label: 'Forma de cobro por defecto',
            placeholder: 'Selecciona forma de cobro por defecto',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        expenseAccountProvider: {
            label: 'Número cuenta contable de ingreso por defecto',
            placeholder: 'Selecciona número cuenta contable de ingreso por defecto',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        paymentProviderUid: {
            label: 'Número cuenta contable de ingreso por defecto',
            placeholder: 'Selecciona número cuenta contable de ingreso por defecto',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        providerEfectivoId: {
            label: 'Caja/Efectivo',
            placeholder: 'Selecciona Caja/Efectivo',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        providerPartnersId: {
            label: 'Caja/Efectivo',
            placeholder: 'Selecciona Caja/Efectivo',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        accountNumberProvider: {
            label: 'Cuenta contable',
            placeholder: ''
        },
        taxProviderUid: {
            label: 'Impuesto por defecto',
            placeholder: 'Impuesto por defecto',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        taxProviderSecondUid: {
            label: 'Segundo impuesto por defecto',
            placeholder: 'Segundo impuesto por defecto',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        assignedCode: {
            label: 'Código asignado',
            placeholder: 'Introduce código asignado'
        },
        expirationProvider: {
            label: 'Vencimiento de factura por defecto',
            placeholder: 'Introduce vencimiento de factura por defecto'
        },
        arrendador: {
            label: 'Arrendador',
            placeholder: 'Arrendador',
        },
        referencia_catastro: {
            label: 'Referencia catastral',
            placeholder: 'Introduce Referencia catastral',
        }
    }


    constructor(private fb: UntypedFormBuilder) { }

    ngOnInit(): void {
        this.form = this.fb.group({
            paymentTypeProvider: [null, Validators.required],
            paymentProviderUid: [null, Validators.required],
            providerEfectivoId: [null, Validators.required],
            providerPartnersId: [null, Validators.required],
            expenseAccountProvider: [null, Validators.required],
            accountNumberProvider: [null, Validators.required],
            taxProviderUid: [null, Validators.required],
            taxProviderSecondUid: [null, Validators.required],
            expirationProvider: [null, Validators.required],
            arrendador: [null, Validators.required],
            referencia_catastro: [null, Validators.required],
        });
    }

    loadStreetTypes(): Option[] {
        return [
            { value: '08', label: 'Barcelona' },
            { value: '28', label: 'Madrid' }
        ];
    }

    provinciaConfig: SelectConfig = {
        label: 'Provincia',
        placeholder: 'Selecciona provincia',
        multiple: false,
        loadOptions: () => this.loadProvincias()
    };

    municipioConfig: SelectConfig = {
        label: 'Municipio',
        placeholder: 'Selecciona municipio',
        multiple: false,
        loadOptions: () => this.loadMunicipios(this.form.get('provincia')!.value)
    };

    loadProvincias(): Option[] {
        return [
            { value: '08', label: 'Barcelona' },
            { value: '28', label: 'Madrid' }
        ];
    }

    loadMunicipios(provincia: string): Option[] {
        if (provincia === '08') {
            return [
                { value: '08019', label: 'Barcelona' },
                { value: '08101', label: 'L\'Hospitalet' }
            ];
        } else if (provincia === '28') {
            return [
                { value: '28079', label: 'Madrid' },
                { value: '28123', label: 'Getafe' }
            ];
        }
        return [];
    }

    onProvinciaChange(): void {
        const provincia = this.form.get('provincia')!.value;
        this.municipioConfig = {
            ...this.municipioConfig,
            key: Date.now(), // clave única que cambia en cada llamada
            loadOptions: () => this.loadMunicipios(provincia)
        };

        this.form.get('municipio')!.reset();
    }
}
